












import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class NodeSummaryRow extends Vue {
  //Значение
  @Prop({required: true})
  value!: number;

  //Единицы измерения
  @Prop({required: true})
  unit!: string;

  //Иконка
  @Prop({required: true})
  icon!: string;

  @Prop({required: false, default: 2})
  viewRoundingAccuracy!: number;

  get formattedValue() {
    if (this.value == null) return 'н/д';
    let val = this.value;
    if (this.value > 100000) val = this.value / 1000;
    return val.toFixed(this.viewRoundingAccuracy);
  }

  get formattedUnit() {
    const unit = this.unit != '-' ? this.unit : '';
    if (this.value && this.value > 10000) return `тыс. ${unit}`;
    return `${unit}`;
  }
}
